import React from 'react';
import ReactDOM from 'react-dom';
import 'font-awesome/css/font-awesome.min.css';

import { Layout } from 'components/grid';

import * as serviceWorker from './serviceWorker';

import './index.scss';
import './i18n';

ReactDOM.render(<Layout.Root />, document.getElementById('root'));
serviceWorker.unregister();
